export const experiences = [
  {
    company: "Nomba",
    role: "Software Engineer",
    country: "Nigeria",
    duration: "May 2026 — Present",
    bullets: [],
    tools: "",
    link: "https://nomba.com/",
  },
  {
    company: "Ojanow",
    role: "Software Engineer",
    country: "Nigeria",
    duration: "December 2023 — August 2026",
    bullets: [
      "Designed and implemented a scalable microservice architecture for a quick-commerce and bill payment platform, enhancing modularity and system performance.",
      "Deployed and managed a private VPN server and Hashicorp Vault, securing internal services and limiting exposure of critical resources.",
      "Set up a monitoring dashboard providing real-time insights into system performance.",
      "Migrated infrastructure to private IPs, reducing operational costs by 32%.",
    ],
    tools: "Node.js, Next.js, React.js, Tailwind, Nest.js, GraphQL, PostgreSQL, Docker, Terraform, Linux, Kubernetes, AWS, Prometheus, Grafana",
    link: "https://ojanowapp.com/",
  },
  {
    company: "Identigo",
    role: "Lead Backend Engineer",
    country: "Nigeria",
    duration: "September 2024 — December 2025",
    bullets: [
      "Architected backend services using Node.js and PostgreSQL, with a strong focus on performance, data integrity, and extensibility.",
      "Implemented Redis and RabbitMQ to handle asynchronous processing, retries, and high-throughput identity checks.",
    ],
    tools: "Node.js, Java, Spring Boot, Linux, PostgreSQL, Docker, Redis, RabbitMQ",
    link: "https://www.identigo.africa/",
  },
  {
    company: "Bpayex",
    role: "Lead Backend Engineer",
    country: "Nigeria",
    duration: "May 2024 — September 2024",
    bullets: [
      "Led a backend team building a web3 digital asset trading platform, increasing transaction processing speed by 36% through optimized database queries and backend logic.",
      "Designed scalable APIs and event-driven architecture using RabbitMQ, reducing system load and improving real-time processing by 35%.",
    ],
    tools: "Node.js, Redis, Docker, MongoDB, WebSockets, SQL",
    link: "https://bpayex.com/",
  },
  {
    company: "Pleno",
    role: "Software Engineer",
    country: "Germany",
    duration: "August 2023 — May 2024",
    bullets: [
      "Built a GIS file extraction service, enhancing data processing speeds and reducing latency.",
      "Led the development of a high-performance GIS backend, increasing efficiency by 30% through Rust-based microservices.",
      "Developed and tested a coordinate processing service, ensuring reliability and accuracy with comprehensive test suites.",
    ],
    tools: "Rust, Python, PostgreSQL, Docker, GCP, gRPC, BigQuery",
    link: "https://www.pleno.tech/",
  },
  {
    company: "Applistructure",
    role: "Software Engineer",
    country: "Nigeria",
    duration: "April 2022 — December 2023",
    bullets: [
      "Led the architecture and development of a financing platform, optimizing transaction workflows and improving scalability.",
      "Integrated multiple payment processors, enhancing payment efficiency and fraud detection by 30%.",
      "Developed real-time messaging for instant user communication, increasing engagement by 37%.",
    ],
    tools: "TypeScript, Node.js, Express, React, SQL, Next.js, Redis, MongoDB",
    link: "https://www.applistructureconsulting.com",
  },
];

export const education = {
  school: "University of Ilorin, Nigeria",
  degree: "B.Sc, Computer Science",
  duration: "2018 — 2022",
  coursework:
    "Distributed Systems, Operating Systems, Computer Architecture, Parallel Programming, Software Engineering, Algorithms & Data Structures",
};

export const certifications = [
  {
    name: "Master Microservices with SpringBoot, Docker, Kubernetes",
    issuer: "Udemy",
    date: "December 2024",
  },
];

export const skills = {
  Languages: ["Rust", "TypeScript", "Python", "Java", "Golang"],
  Frameworks: [
    "Node.js",
    "Next.js",
    "React.js",
    "Express.js",
    "Nest.js",
    "Spring Boot",
    "Actix Web",
    "FastAPI",
    "Gin",
  ],
  "Software & Tools": [
    "SQL",
    "GraphQL",
    "Git",
    "Redis",
    "Docker",
    "Kafka",
    "MongoDB",
    "AWS",
    "GCP",
    "gRPC",
  ],
};
